<template>
  <div class="Fuell-Table" ref="table">
    <div class="Fuell-Table--header">
      <div class="Fuell-Table--item Fuell-Table--sortable">
        <span v-t="{path: 'transactions_charged_table_header_status'}"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{path:'transactions_charged_table_header_user'}"></span>
        <span class="sortable-handler"></span>
      </div>

      <div class="Fuell-Table--item ">
        <span v-t="{path: 'transactions_charged_table_header_date'}"></span>
        <span class="sortable-handler"></span>
      </div>
      <div class="Fuell-Table--item ">
        <span v-t="{path: 'transactions_table_activity_group_category'}"></span>
      </div>

      <div class="Fuell-Table--item ">
        <span v-t="{path: 'transactions_charged_table_header_amount'}"></span>
      </div>
      <!--
      <div class="Fuell-Table--item">
      </div>
-->
    </div>

    <div class="Fuell-Table--content">
      <benefits-transactions-table-row
        v-for="transaction in benefitTransactions"
        @showEditTransactionModal="emitShowTransactionModal"
        :key="transaction.id"
        :transaction="transaction"
      ></benefits-transactions-table-row>
      <div
        class="Fuell-Table--spinner"
        v-if="isLoadingTransactions"
      >
        <spinner></spinner>
      </div>
    </div>
  </div>
</template>

<script>
import BenefitsTransactionsTableRow from './BenefitsTransactionsTableRow'
import Spinner from '@/components/Commons/Spinner'
import _paginationHandlerMixin from '@/components/Commons/_mixins/_paginationHandlerMixin'
export default {
  name: 'BenefitsTransactionsTable',
  components: { BenefitsTransactionsTableRow, Spinner },
  mixins: [

    _paginationHandlerMixin
  ],
  methods: {
    emitShowTransactionModal (event) {
      this.$emit('showEditTransactionModal', event)
    },
    nextPage () {
      this.$store.dispatch('TransactionsStore/nextFlexibleRemunerationTransactionsPage')
    }

  },
  computed: {
    benefitTransactions () {
      return this.$store.getters['TransactionsStore/transactions'].filter(el => el.budget && el.budget.type.code === 'FLEXIBLE_REMUNERATION')
    },
    currentPage () {
      return this.$store.getters['TransactionsStore/currentPage']
    },
    lastPage () {
      return this.$store.getters['TransactionsStore/lastPage']
    },
    isLoadingTransactions () {
      return this.$store.getters['TransactionsStore/isLoadingTransactions']
    }

  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/tables/benefits-transactions.scss";
</style>
